import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserId } from 'flowhawk-core';
import type { RootState } from '../../../../Redux';
import { createTeam } from '../../../../Redux/TeamActions';
import CreateEditTeam from '../../../../Components/CreateEditTeam';
import type { UserProfile } from '../../../../Utils/types';
import { useSocketStatus } from '../../../../Selectors/hooks';

export const Route = createFileRoute('/(main)/_layout/teams/_teams/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isConnected } = useSocketStatus();

  const teams = useSelector((state: RootState) => state.team.teams || []);
  const teamsLoading = useSelector((state: RootState) => state.loading.teams || false);
  const saveTeamLoading = useSelector((state: RootState) => state.loading.saveTeam || false);
  const authState = useSelector((state: RootState) => state.auth);
  const memberId = selectUserId(authState);
  const contactsMap = useSelector((state: RootState) => state.chatroom.contactsMap || {});
  const contactsOrder = useSelector((state: RootState) => state.chatroom.contactsOrder || []);
  const contactsAreLoaded = useSelector((state: RootState) => state.chatroom.contactsAreLoaded || false);
  const singleUserAdded = useSelector((state: RootState) => state.chatroom.singleUserAdded || false);
  const newUserInvited = useSelector((state: RootState) => state.chatroom.newUserInvited || false);

  const handleCreate = (teamName: string, teamMembers: UserProfile[], shared: boolean) => {
    dispatch(createTeam(teamName, teamMembers, shared));
  };

  const handleClose = () => {
    navigate({ to: '/teams' });
  };

  return (
    <div className="team-detail-content">
      <CreateEditTeam
        isConnected={isConnected}
        teams={teams}
        teamsLoading={teamsLoading}
        contactsMap={contactsMap}
        contactsOrder={contactsOrder}
        contactsAreLoaded={contactsAreLoaded}
        memberId={memberId}
        team={undefined}
        canEdit={true}
        canDelete={false}
        singleUserAdded={singleUserAdded}
        newUserInvited={newUserInvited}
        saveTeamLoading={saveTeamLoading}
        onClose={handleClose}
        onCreate={handleCreate}
        onUpdate={() => {}}
        onDelete={() => {}}
      />
    </div>
  );
}
